import React, { useState, useEffect } from 'react';
import { Message, ToastContainer } from './Toast.styles';
import { createPortal } from 'react-dom';

const toastPortal = 'toasts';

const addPortal = () => {
	const portal = document.createElement('div');
	portal.id = toastPortal;
	document.body.appendChild(portal);
	return portal;
};

const getPortal = () => {
	return document.getElementById(toastPortal) || addPortal();
};

const Toast = ({ message, status, time }) => {
	const [visible, setVisible] = useState(true);

	useEffect(
		() => {
			const timer = setTimeout(() => {
				setVisible(false);
			}, time);

			return () => clearTimeout(timer);
		}, // eslint-disable-next-line
		[]
	);

	return createPortal(
		<ToastContainer status={status} visible={visible}>
			<Message>{message}</Message>
		</ToastContainer>,
		getPortal()
	);
};

export default Toast;
